import React from "react";
import { Button, Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import img from "../assets/images/TF1000(IND).jpg";

const Blogs = () => {
  return (
    <>
      <div
        className="top-strip p-3 d-none d-xl-block"
        style={{ backgroundColor: "#F3F0F0" }}
      >
        <Container fluid>
          {" "}
          <Row className="d-flex justify-content-between align-items-center mx-0">
            {" "}
            {/* Left Part */}
            <Col xs={12} md="auto" className="d-flex align-items-center px-0">
              {" "}
              <p className="text-black fw-bold fs-4 ">Blogs</p>
            </Col>
            {/* Right Part */}
            <Col xs={12} md="auto" className="d-flex align-items-center px-0">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-12 col-md-0">
                    <p>Home / Blogs</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Container>
        <Row className="py-5">
          {/* Left Column (30%) */}
          <Col md={4} className="d-flex flex-column justify-content-center ">
            <Card className="shadow mb-4" style={{ backgroundColor: "white" }}>
              <Card.Body>
                <Card.Title
                  className="fw-bold mb-4 text-start"
                  style={{ color: "#121736" }}
                >
                  Recent Posts
                </Card.Title>

                <div className="mb-1 text-black text-start">
                  <div>
                    <h6 className="fw-bold mb-1" style={{ color: "#121736" }}>
                      1. Lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum
                    </h6>
                    <h6 className="mb-1" style={{ color: "#3B3B3B" }}>
                      lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum lorem ipsum
                    </h6>
                  </div>
                  <div className="d-flex justify-content-between">
                    <hr className="flex-grow-1 me-2" />
                    <a
                      href="#"
                      size="sm"
                      style={{ color: "#121736", fontWeight: "bold" }}
                    >
                      Read More...
                    </a>
                  </div>
                </div>

                <div className="mb-1 text-black text-start">
                  <div>
                    <h6 className="fw-bold mb-1" style={{ color: "#121736" }}>
                      1. Lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum
                    </h6>
                    <h6 className="mb-1" style={{ color: "#3B3B3B" }}>
                      lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum lorem ipsum
                    </h6>
                  </div>
                  <div className="d-flex justify-content-between">
                    <hr className="flex-grow-1 me-2" />
                    <a
                      href="#"
                      size="sm"
                      style={{ color: "#121736", fontWeight: "bold" }}
                    >
                      Read More...
                    </a>
                  </div>
                </div>
              </Card.Body>
            </Card>

            <Card className="shadow mb-4" style={{ backgroundColor: "white" }}>
              <Card.Body>
                <Card.Title
                  className="fw-bold mb-4 text-start"
                  style={{ color: "#121736" }}
                >
                  Top Posts
                </Card.Title>

                <div className="mb-1 text-black text-start">
                  <div>
                    <h6 className="fw-bold mb-1" style={{ color: "#121736" }}>
                      1. Lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum
                    </h6>
                    <h6 className="mb-1" style={{ color: "#3B3B3B" }}>
                      lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum lorem ipsum
                    </h6>
                  </div>
                  <div className="d-flex justify-content-between">
                    <hr className="flex-grow-1 me-2" />
                    <a
                      href="#"
                      size="sm"
                      style={{ color: "#121736", fontWeight: "bold" }}
                    >
                      Read More...
                    </a>
                  </div>
                </div>

                <div className="mb-1 text-black text-start">
                  <div>
                    <h6 className="fw-bold mb-1" style={{ color: "#121736" }}>
                      1. Lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum
                    </h6>
                    <h6 className="mb-1" style={{ color: "#3B3B3B" }}>
                      lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum lorem ipsum
                    </h6>
                  </div>
                  <div className="d-flex justify-content-between">
                    <hr className="flex-grow-1 me-2" />
                    <a
                      href="#"
                      size="sm"
                      style={{ color: "#121736", fontWeight: "bold" }}
                    >
                      Read More...
                    </a>
                  </div>
                </div>

                <div className="mb-1 text-black text-start">
                  <div>
                    <h6 className="fw-bold mb-1" style={{ color: "#121736" }}>
                      1. Lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum
                    </h6>
                    <h6 className="mb-1" style={{ color: "#3B3B3B" }}>
                      lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum lorem ipsum
                    </h6>
                  </div>
                  <div className="d-flex justify-content-between">
                    <hr className="flex-grow-1 me-2" />
                    <a
                      href="#"
                      size="sm"
                      style={{ color: "#121736", fontWeight: "bold" }}
                    >
                      Read More...
                    </a>
                  </div>
                </div>
                <div className="mb-1 text-black text-start">
                  <div>
                    <h6 className="fw-bold mb-1" style={{ color: "#121736" }}>
                      1. Lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum
                    </h6>
                    <h6 className="mb-1" style={{ color: "#3B3B3B" }}>
                      lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum lorem ipsum
                    </h6>
                  </div>
                  <div className="d-flex justify-content-between">
                    <hr className="flex-grow-1 me-2" />
                    <a
                      href="#"
                      size="sm"
                      style={{ color: "#121736", fontWeight: "bold" }}
                    >
                      Read More...
                    </a>
                  </div>
                </div>
                <div className="mb-1 text-black text-start">
                  <div>
                    <h6 className="fw-bold mb-1" style={{ color: "#121736" }}>
                      1. Lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum
                    </h6>
                    <h6 className="mb-1" style={{ color: "#3B3B3B" }}>
                      lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem
                      ipsum lorem ipsum
                    </h6>
                  </div>
                  <div className="d-flex justify-content-between">
                    <hr className="flex-grow-1 me-2" />
                    <a
                      href="#"
                      size="sm"
                      style={{ color: "#121736", fontWeight: "bold" }}
                    >
                      Read More...
                    </a>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Right Column (70%) */}
          {/* Right Column (70%) */}
          <Col md={8} className="d-flex justify-content-end flex-wrap">
            {[...Array(3)].map((_, rowIndex) => (
              <Row key={rowIndex} className="w-100 mb-3">
                <Col md={6} className="d-flex justify-content-center">
                  <Card style={{ width: "25rem" }}>
                    <Card.Img variant="top" src={img} />
                    <Card.Body>
                      <Card.Title>Card Title</Card.Title>
                      <Card.Text>
                        Some quick example text to build on the card title and
                        make up the bulk of the card's content.
                      </Card.Text>
                      <a variant="primary">Go somewhere</a>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6} className="d-flex justify-content-center">
                  <Card style={{ width: "25rem" }}>
                    <Card.Img variant="top" src={img} />
                    <Card.Body>
                      <Card.Title>Card Title</Card.Title>
                      <Card.Text>
                        Some quick example text to build on the card title and
                        make up the bulk of the card's content.
                      </Card.Text>
                      <Button variant="primary">Go somewhere</Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            ))}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Blogs;
